(function () {
    'use strict';
    var heightContentDocument = 0;

    angular.module('servicesModule', [])
        .factory('broadcastService', broadcastService)
        .service('documentService', documentService)
        .service('favoriteService', favoriteService)
        .service('localStorageService', localStorageService)
        .service('tabStateService', tabStateService)
        .service('browserService', browserService)
        .service('anchorService', anchorService)
        .service('feedBackService', feedBackService)
        .service('readingConfirmationService', readingConfirmationService)
        .service('debounceService', debounceService)
        .service('documentTemplateService', documentTemplateService)
        .service('resizeService', resizeService)
        .service('stringValidationService', stringValidationService)
        .service('newsService', newsService)
        .service('folderService', folderService)
        .service('treeNavigationService', treeNavigationService)
        .service('routeService', routeService)
        .service('metaDataService', metaDataService)
        .service('shortcutKeysService', shortcutKeysService)
        .service('helpPagesService', helpPagesService)
        .service('configService', configService)
        .service('commonService', commonService);


    //broadcastService
    broadcastService.$inject = ['$rootScope'];
    function broadcastService($rootScope) {
        return function (broadcastType, target, gridSettingKey) {
            $rootScope.$broadcast(broadcastType, target, gridSettingKey);
        };
    };

    //documentService
    documentService.$inject = ['$location', '$state', '$http', 'workersPool', '$q', 'configService'];
    function documentService($location, $state, $http, workersPool, $q, configService) {
        var documents = {};
        var isIE = detectIE();
        var service = {
            setDocuments: setDocuments,
            getDocuments: getDocuments,
            showFullscreen: showFullscreen,
            showNormal: showNormal,
            stickyTitle: stickyTitle,
            goToDocument: goToDocument,
            getDocumentsViaWorker: getDocumentsViaWorker,
            clearDocumentsInWorker: clearDocumentsInWorker,
            getMetaDocumentsViaWorker: getMetaDocumentsViaWorker,
            clearMetaDocumentsInWorker: clearMetaDocumentsInWorker,
            getAgreeFilesForDocuments: getAgreeFilesForDocuments,
            getParentIdExtendDocument: getParentIdExtendDocument,
            checkParentExtensionHasToCompare: checkParentExtensionHasToCompare,
            checkDocumentHaveToCompareById: checkDocumentHaveToCompareById,
            changeUrlBackendToFrontend: changeUrlBackendToFrontend,
            getHearingTooltip: getHearingTooltip
        };

        return service;

        function setDocuments(documentObject) {
            documents = documentObject;
        };

        function getDocuments() {
            return documents;
        };

        function showFullscreen() {
            angular.element('#sidebar-wrapper').addClass('hidesidebar');
            angular.element('#wrapper').addClass('hidesidebar');

            angular.element('#resizeBar').addClass('hidesidebar');

            angular.element('#tab-document-id').hide();
            angular.element('#document-top-menu-identifier').hide();
            angular.element('#handbook-nav').hide();

            angular.element('.tab-content-header').addClass('hidesidebar');
            //angular.element('body').css({ 'padding-top': '0px' });
            angular.element('.main-container_header').hide();

            var mainBody = angular.element(".main-container_body").height();
            var docContent = angular.element("#tab-content-document").height();


            angular.element('#' + documentContent.content + '').css({
                height: (mainBody - docContent - 20)
            });
            angular.element('#documentDetailFieldContentList').css({
                maxHeight: (mainBody - docContent - 250)
            })

            angular.element('#document-content-identifier').addClass('fullScreen-height');
            var element = $location.url().split('/');
            if (element[3] != 'fields' && element[3] != 'hearingfields') {
                setTimeout(function () {
                    stickyTitle();
                    if (isIE) {
                        runInitforIE();
                    }
                }, 500);
            }
        };

        function stickyTitle() {
            var title = document.querySelector('#documentTitle');
            var titlePosition = title ? title.getBoundingClientRect() : { width: 0, height: 0 };
            var content = document.querySelector('#document-content-identifier');
            var contentPosition = content ? content.getBoundingClientRect() : { width: 0, height: 0, top: 0 };
            var placeholder = $("#placeholderTitleId")
            if (placeholder.length > 0) {
                placeholder.remove();
            }
            placeholder = document.createElement('div');
            placeholder.id = "placeholderTitleId";
            //placeholder.style.width = titlePosition.width + 'px';
            placeholder.style.height = titlePosition.height + 'px';
            var isAdded = false;

            var heightToFloat = 0, currentPosition = 0;
            heightToFloat = contentPosition.top + 50;
            var heightScroll = heightContentDocument;
            if ($(window).height() > HandbookConfiguration.DocumentTitleScreenHeight) {
                removeStickyTitle();
                $('#document-content-identifier').scroll(function () {
                    var scrollTop = $('#document-content-identifier').scrollTop();
                    var isfullScreen = $('#document-content-identifier').hasClass('fullScreen-height');
                    currentPosition = isfullScreen ? scrollTop : contentPosition.top + scrollTop;
                    if (currentPosition >= heightToFloat && !isAdded) {
                        title.classList.add('sticky');
                        document.querySelector('#document-content-identifier').classList.add('scrolling');
                        title.parentNode.insertBefore(placeholder, title);
                        isAdded = true;
                        var contentWidth = $('#document-content-identifier').width() + 10;
                        if (!isfullScreen) {
                            $('#documentTitle').css('top', contentPosition.top);
                            $('#documentTitle').css('width', contentWidth);
                            $('#documentTitle').css('background-color', 'white');
                        } else {
                            $('#documentTitle').css('width', contentWidth);
                            $('#documentTitle').css('background-color', 'white');
                        }
                        heightScroll = !isfullScreen ? heightScroll : screen.availHeight - 150;
                        var marginTop = isfullScreen ? "75px" : "115px";
                        $('#document-content-identifier').css('margin-top', marginTop);
                        $('#document-content-identifier').css('height', heightScroll - 60);
                    } else if (currentPosition < heightToFloat && isAdded) {
                        title.classList.remove('sticky');
                        document.querySelector('#document-content-identifier').classList.remove('scrolling');
                        $('#documentTitle').css('top', '');
                        $('#documentTitle').css('width', '');
                        $('#documentTitle').css('background-color', '');
                        $('#documentTitle').css('margin-left', '');
                        if (title.parentNode) {
                            title.parentNode.removeChild(placeholder);
                        }
                        isAdded = false;
                        $('#document-content-identifier').css('margin-top', '0px');
                        $('#document-content-identifier').css('height', heightScroll);
                    }
                });
            }
            else {
                $('#document-content-identifier').scroll(function () {
                    var isfullScreen = $('#document-content-identifier').hasClass('fullScreen-height');
                    currentPosition = isfullScreen ? $('#document-content-identifier').scrollTop() : contentPosition.top + $('#document-content-identifier').scrollTop();

                });
            }
        }

        function runInitforIE(backFromFullScreen) {
            if ($(window).height() > HandbookConfiguration.DocumentTitleScreenHeight) {
                var title = document.querySelector('#documentTitle');
                var titlePosition = title ? title.getBoundingClientRect() : { width: 0, height: 0 };
                var content = document.querySelector('#document-content-identifier');
                var contentPosition = content ? content.getBoundingClientRect() : { width: 0, height: 0, top: 0 };
                var placeholder = $("#placeholderTitleId")
                if (placeholder.length > 0) {
                    placeholder.remove();
                }
                placeholder = document.createElement('div');
                placeholder.id = "placeholderTitleId";
                var heightToFloat = 0, currentPosition = 0;
                heightToFloat = contentPosition.top + 50;
                var heightScroll = $('#document-content-identifier').height();
                var isfullScreen = $('#document-content-identifier').hasClass('fullScreen-height');
                var scrollTop = $('#document-content-identifier').scrollTop();
                currentPosition = isfullScreen ? scrollTop : contentPosition.top + scrollTop;
                if (currentPosition >= heightToFloat) {
                    title.classList.add('sticky');
                    title.parentNode.insertBefore(placeholder, title);
                    var contentWidth = $('#document-content-identifier').width() + 10;
                    if (!isfullScreen) {
                        $('#documentTitle').css('top', contentPosition.top);
                        $('#documentTitle').css('width', contentWidth);
                        $('#documentTitle').css('background-color', 'white');
                    } else {
                        $('#documentTitle').css('width', contentWidth);
                        $('#documentTitle').css('background-color', 'white');
                    }
                    heightScroll = !isfullScreen ? heightScroll : screen.availHeight - 150;
                    var marginTop = isfullScreen ? "50px" : "100px";
                    $('#document-content-identifier').css('margin-top', marginTop);
                    var extraHeight = (backFromFullScreen && !isfullScreen) ? 50 : 20;
                    $('#document-content-identifier').css('height', heightScroll - 50 - extraHeight);
                }
            }
        }

        function removeStickyTitle() {
            var title = document.querySelector('#documentTitle');
            if (title) {
                title.classList.remove('sticky');
            }
            $('#documentTitle').css('top', '');
            $('#documentTitle').css('width', '');
            $('#documentTitle').css('background-color', '');
            $('#documentTitle').css('margin-left', '');
            var placeholder = document.querySelector('#placeholderTitleId');
            if (placeholder != null && title) {
                title.parentNode.removeChild(placeholder);
            }

            if (document.querySelector('#document-content-identifier'))
                document.querySelector('#document-content-identifier').classList.remove('scrolling');
            $('#document-content-identifier').unbind('scroll');
        }

        function showNormal() {
            angular.element('#sidebar-wrapper').removeClass('hidesidebar');
            angular.element('#wrapper').removeClass('hidesidebar');

            angular.element('#resizeBar').removeClass('hidesidebar');

            angular.element('#tab-document-id').show();
            angular.element('#document-top-menu-identifier').show();
            angular.element('#handbook-nav').show();

            angular.element('.tab-content-header').removeClass('hidesidebar');
            //angular.element('body').css({ 'padding-top': '34px' });
            angular.element('.main-container_header').show();

            angular.element('#document-content-identifier').removeClass('fullScreen-height');
            var element = $location.url().split('/');
            if (element[3] != 'fields' && element[3] != 'hearingfields' && isIE) {
                setTimeout(function () {
                    stickyTitle();
                    runInitforIE(true);
                }, 500);
            }
        };

        function goToDocument(documentId, defaultFieldView) {

            $state.go(handbookActions.DocumentAction, {
                documentId: documentId
            });

        }

        function getDocumentsViaWorker(folderId, previousViewType) {
            var deffered = $q.defer();
            var worker = workersPool['document-worker.js'];
            worker.postMessage([
                'fetch',
                folderId,
                {
                    publishedInternet: globalResources.publishedInternet,
                    unpublishedInternet: globalResources.unpublishedInternet,
                    UndefinedMetatag: globalResources.UndefinedMetatag
                },
                previousViewType
            ]);
            worker.onmessage = function (e) {
                var result = e.data;
                deffered.resolve(result);
            }

            return deffered.promise;
        }

        function clearDocumentsInWorker() {
            var worker = workersPool['document-worker.js'];
            worker.postMessage([
                'clear'
            ]);;
        }

        function getMetaDocumentsViaWorker(folderId, metadataGroupId, recursively, includeLevel1, documents) {
            var deffered = $q.defer();
            var worker = workersPool['meta-data-document-worker.js'];
            worker.postMessage([
                'fetch',
                folderId,
                metadataGroupId,
                recursively,
                includeLevel1,
                documents,
                {
                    UndefinedMetatag: globalResources.UndefinedMetatag
                }
            ]);
            worker.onmessage = function (e) {
                var result = e.data;
                deffered.resolve(result);
            }

            return deffered.promise;
        }

        function clearMetaDocumentsInWorker() {
            var worker = workersPool['meta-data-document-worker.js'];
            worker.postMessage([
                'clear'
            ]);;
        }

        function getAgreeFilesForDocuments(documents) {
            if (documents == null || documents.length == 0 || HandbookConfiguration.EnabledAgree.toLowerCase() !== "true") {
                return documents;
            }

            var documentIds = [];
            for (var i = 0; i < documents.length; i++) {
                if (documents[i].hasAgreeFiles) {
                    documentIds.push(documents[i].id);
                }
            }

            if (!documentIds.length) {
                return documents;
            }

            $http.get('/api/Documents/GetAgreeFilesForDocuments', { params: { documentIds: documentIds } })
                .success(function (data) {

                    if (!data || !data.length) {
                        return;
                    }

                    for (var i = 0; i < documents.length; i++) {
                        var document = documents[i];

                        if (!document.hasAgreeFiles) {
                            continue;
                        }

                        document.agreeFiles = [];

                        for (var j = 0; j < data.length; j++) {
                            var item = data[j];
                            if (item.documentId == document.id) {
                                document.agreeFiles.push(item);
                            }
                        }
                    }
                });

        }

        function getParentIdExtendDocument(childId, hearingMode) {
            return $http
                .get('/api/Documents/GetParentIdExtendDocument', {
                    params: {
                        'childId': childId,
                        'isBackend': hearingMode ? true : false
                    }
                })
                .then(function (response) {
                    return response.data;
                });
        }

        function checkParentExtensionHasToCompare(childId) {
            return $http.get(handbookRequests.CheckParentExtensionHasToCompare, {
                params: {
                    'childId': childId
                }
            }).then(function (response) {
                return configService.getBool(response.data);
            });
        }

        function checkDocumentHaveToCompareById(documentId, hearingMode) {
            return $http.get(handbookRequests.CheckDocumentHaveToCompareById, {
                params: {
                    'documentId': documentId,
                    'isBackend': hearingMode ? true : false
                }

            }).then(function (response) {
                return configService.getBool(response.data);
            });
        }

        function changeUrlBackendToFrontend(urlFrontEnd, content, isHearing = false, frontEndDeviationUrl = null) {
            if (content == null) {
                return content;
            }
            var hrefs = content.match(/href="([^"]*)/g);
            if (hrefs != null && hrefs.length > 0) {
                for (var i = 0; i < hrefs.length; i++) {
                    var folders = hrefs[i].match('="/folder/([0-9]+)$');
                    if (folders != null && folders.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplace = hrefs[i].replace('/folder/', urlFrontEnd + '/folder/');
                        content = content.replace(reg, strReplace);
                        continue;
                    }
                    var documents = hrefs[i].match('="/document/([0-9]+)|(#[a-z]+)$');
                    if (documents != null && documents.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplaceDocument = hrefs[i].replace('/document/', urlFrontEnd + '/document/');
                        content = content.replace(reg, strReplaceDocument);
                        continue;
                    }

                    var areas = hrefs[i].match('="/area/detail/(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}');
                    if (areas != null && areas.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplace = hrefs[i].replace('/area/detail/', urlFrontEnd + '/process-fe/area/detail/');
                        content = content.replace(reg, strReplace);
                        continue;
                    }

                    var areasHref = hrefs[i].match('="/process/area/detail/(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}');
                    if (areasHref != null && areasHref.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplace = hrefs[i].replace('/process/area/detail/', urlFrontEnd + '/process-fe/area/detail/');
                        content = content.replace(reg, strReplace);
                        continue;
                    }

                    var processes = hrefs[i].match('="/process-detail/([0-9]+)|(#[a-z]+)$');
                    if (processes != null && processes.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplaceDocument = hrefs[i].replace('/process-detail/', urlFrontEnd + '/process-fe/process-detail/');
                        content = content.replace(reg, strReplaceDocument);
                        continue;
                    }

                    var processesHref = hrefs[i].match('="/process/process-detail/([0-9]+)|(#[a-z]+)$');
                    if (processesHref != null && processesHref.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplaceDocument = hrefs[i].replace('/process/process-detail/', urlFrontEnd + '/process-fe/process-detail/');
                        content = content.replace(reg, strReplaceDocument);
                        continue;
                    }

                    var db4Link = hrefs[i].match('="/Modules/Module_136/');
                    if (db4Link != null && db4Link.length > 0) {
                        var strReplaceDb4Link = hrefs[i].replace('/Modules/Module_136/', urlFrontEnd + '/Modules/Module_136/');
                        content = content.replace(hrefs[i], strReplaceDb4Link);
                        continue;
                    }

                    db4Link = hrefs[i].match('="../../Modules/Module_136/');
                    if (db4Link != null && db4Link.length > 0) {
                        var strReplaceDb4Link = hrefs[i].replace('../../Modules/Module_136/', urlFrontEnd + '/Modules/Module_136/');
                        content = content.replace(hrefs[i], strReplaceDb4Link);
                        continue;
                    }

                    db4Link = hrefs[i].match('="handbook_view.aspx');
                    if (db4Link != null && db4Link.length > 0) {
                        var strReplaceDb4Link = hrefs[i].replace('handbook_view.aspx', urlFrontEnd + '/handbook_view.aspx');
                        content = content.replace(hrefs[i], strReplaceDb4Link);
                        continue;
                    }

                    db4Link = hrefs[i].match('="view_document.aspx');
                    if (db4Link != null && db4Link.length > 0) {
                        var strReplaceDb4Link = hrefs[i].replace('view_document.aspx', urlFrontEnd + '/view_document.aspx');
                        content = content.replace(hrefs[i], strReplaceDb4Link);
                        continue;
                    }

                    db4Link = hrefs[i].match('="maincontent_fs.aspx');
                    if (db4Link != null && db4Link.length > 0) {
                        var strReplaceDb4Link = hrefs[i].replace('maincontent_fs.aspx', urlFrontEnd + '/maincontent_fs.aspx');
                        content = content.replace(hrefs[i], strReplaceDb4Link);
                        continue;
                    }

                    db4Link = hrefs[i].match('="/handbook_view.aspx');
                    if (db4Link != null && db4Link.length > 0) {
                        var strReplaceDb4Link = hrefs[i].replace('/handbook_view.aspx', urlFrontEnd + '/handbook_view.aspx');
                        content = content.replace(hrefs[i], strReplaceDb4Link);
                        continue;
                    }

                    db4Link = hrefs[i].match('="/view_document.aspx');
                    if (db4Link != null && db4Link.length > 0) {
                        var strReplaceDb4Link = hrefs[i].replace('/view_document.aspx', urlFrontEnd + '/view_document.aspx');
                        content = content.replace(hrefs[i], strReplaceDb4Link);
                        continue;
                    }

                    db4Link = hrefs[i].match('="/maincontent_fs.aspx');
                    if (db4Link != null && db4Link.length > 0) {
                        var strReplaceDb4Link = hrefs[i].replace('/maincontent_fs.aspx', urlFrontEnd + '/maincontent_fs.aspx');
                        content = content.replace(hrefs[i], strReplaceDb4Link);
                        continue;
                    }
                    if (isHearing) {
                        var fileLink = hrefs[i].match('="/api/File/GetFile?');
                        if (fileLink != null && fileLink.length > 0) {
                            var strReplace = hrefs[i].replace('/File/GetFile?', '/File/GetFile?isLastVersion=true&');
                            content = content.replace(hrefs[i], strReplace);
                            continue;
                        }
                        if (hrefs[i].indexOf('stream_file.aspx?') >= 0) {
                            var strReplace = hrefs[i].replace('stream_file.aspx?', 'stream_file.aspx?isLastVersion=true&');
                            content = content.replace(hrefs[i], strReplace);
                            continue;
                        }
                        if (hrefs[i].indexOf('internal_streamfile.aspx?') >= 0) {
                            var strReplace = hrefs[i].replace('internal_streamfile.aspx?', 'internal_streamfile.aspx?isLastVersion=true&');
                            content = content.replace(hrefs[i], strReplace);
                            continue;
                        }
                    }

                    var interconnectedProcess = hrefs[i].match('="/process-interconnected/([0-9]+)|(#[a-z]+)$');
                    if (interconnectedProcess != null && interconnectedProcess.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplaceDocument = hrefs[i].replace('/process-interconnected/', urlFrontEnd + '/process-fe/process-interconnected/');
                        content = content.replace(reg, strReplaceDocument);
                        continue;
                    }

                    interconnectedProcess = hrefs[i].match('="/process/process-interconnected/([0-9]+)|(#[a-z]+)$');
                    if (interconnectedProcess != null && interconnectedProcess.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplaceDocument = hrefs[i].replace('/process/process-interconnected/', urlFrontEnd + '/process-fe/process-interconnected/');
                        content = content.replace(reg, strReplaceDocument);
                        continue;
                    }

                    if (frontEndDeviationUrl != null) {
                        var deviation = hrefs[i].match('="/register/([0-9]+)/([0-9]+)$');
                        if (deviation != null && deviation.length > 0) {
                            var reg = new RegExp(hrefs[i], "g");
                            var strReplaceDocument = hrefs[i].replace('/register/', frontEndDeviationUrl + '/register/');
                            content = content.replace(reg, strReplaceDocument);
                            continue;
                        }
                    }

                    var checklist = hrefs[i].match('="/implement/add/(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}');
                    if (checklist != null && checklist.length > 0) {
                        var reg = new RegExp(hrefs[i], "g");
                        var strReplaceDocument = hrefs[i].replace('/implement/add/', urlFrontEnd + '/checklist-fe/implement/add/');
                        content = content.replace(reg, strReplaceDocument);
                        continue;
                    }
                }
            }

            if (isHearing) {
                var src = content.match(/src="([^"]*)/g);
                if (src != null && src.length > 0) {
                    for (var i = 0; i < src.length; i++) {
                        if (src[i].indexOf('stream_image.aspx?') >= 0) {
                            var strReplace = src[i].replace('stream_image.aspx?', 'stream_image.aspx?isLastVersion=true&');
                            content = content.replace(src[i], strReplace);
                            continue;
                        }

                        if (src[i].indexOf('Handbook/internal_streamfile.aspx?') >= 0) {
                            var strReplace = src[i].replace('Handbook/internal_streamfile.aspx?', 'Handbook/internal_streamfile.aspx?isLastVersion=true&');
                            content = content.replace(src[i], strReplace);
                            continue;
                        }
                    }
                }
            }
            return content;
        };
    };

    //favoriteService
    function favoriteService() {
        var favoriteState = {
            isFavorited: false,
            id: 0,
            type: 0
        };

        var service = {
            setFavoriteNodeState: setFavoriteNodeState,
            getFavoriteNodeState: getFavoriteNodeState
        };

        return service;

        function setFavoriteNodeState(data) {
            favoriteState = data;
        };

        function getFavoriteNodeState() {
            return favoriteState;
        };
    };

    //localStorageService
    function localStorageService() {
        var localStorageSupported = typeof (Storage) != "undefined";

        var service = {
            getItem: getItem,
            setItem: setItem,
            removeItem: removeItem,
            clearAll: clearAll
        };

        return service;

        function getItem(key) {
            if (localStorageSupported) {
                return localStorage.getItem(key);
            }
        };

        function setItem(key, value) {
            if (localStorageSupported) {
                localStorage.setItem(key, value);
            }
        };

        function removeItem(key) {
            if (localStorageSupported) {
                localStorage.removeItem(key);
            }
        };

        function clearAll() {
            if (localStorageSupported) {
                localStorage.clear();
            }
        };
    };

    //tabStateService
    tabStateService.$inject = ['localStorageService', '$timeout', 'broadcastService', 'documentService', '$location'];
    function tabStateService(localStorageService, $timeout, broadcastService, documentService, $location) {
        var currentStateType = '',
            currentTabState = '';

        var service = {
            getState: getState,
            setState: setState,
            removeState: removeState,
            setCurrentStateType: setCurrentStateType,
            getCurrentStateType: getCurrentStateType,
            setCurrentTabState: setCurrentTabState,
            getCurrentTabState: getCurrentTabState,
            initTabState: initTabState,
            isTabActive: isTabActive,
            closeOpenedTabIfNoPrivilege: closeOpenedTabIfNoPrivilege,
            adjustContentPosition: adjustContentPosition,
            adjustContentHeightPosition: adjustContentHeightPosition,
            adjustContentHeightHomeStartPageTab: adjustContentHeightHomeStartPageTab,
            adjustFolderContentIdentifierHeight: adjustFolderContentIdentifierHeight
        };

        return service;

        function getState(tabStateType) {
            return localStorageService.getItem(tabStateType);
        };

        function setState(tabStateType, elementId) {
            localStorageService.setItem(tabStateType, elementId);
        };

        function removeState(tabStateType) {
            localStorageService.removeItem(tabStateType);
        };

        function setCurrentStateType(stateType) {
            currentStateType = stateType;
        };

        function getCurrentStateType() {
            return currentStateType;
        };

        function setCurrentTabState(tabState) {
            currentTabState = tabState;
        };

        function getCurrentTabState() {
            return currentTabState;
        };

        function initTabState(stateType) {
            var tabState = localStorageService.getItem(stateType);
            //if (!tabState && stateType == tabStateType.chapterTabState) {
            //    tabState = folderTabs.content;
            //}

            //if (!tabState && stateType == tabStateType.documentTabState) {
            //    tabState = documentTabs.content;
            //}

            $(window).on('resize', function () {
                // This function use to adjust the height of document content/folder content when user try to resize browser viewport.
                // TODO: If we regardless the height of document/folder when user resize browser viewport, we can remove this code.
                if (currentStateType == stateType) {
                    if (currentTabState == null || currentTabState == "") {
                        currentTabState = tabState;
                    }

                    adjustContentPosition(currentTabState, stateType);
                }
                if ($('#documentTitle').length == 1) {
                    var contentWidth = $('#documentHeader1Container').width() + 10;
                    $('#documentTitle').css('width', contentWidth);
                }
            });

            if (tabState != undefined) {
                angular.element(prefix.hashbangPrefix + tabState).addClass(cssClass.active);
                var elementActive = angular.element(prefix.hashbangPrefix + tabState + ' a').attr('href');
                if (elementActive != undefined) {
                    var activePanel = elementActive.replace(prefix.hashbangPrefix, '');
                    angular.element(prefix.hashbangPrefix + activePanel).addClass(cssClass.active);
                }
                if (tabState == 'chapter-whats-new') {
                    broadcastService('ActiveFolderWhatsnew', {});
                }
            }

            $timeout(function () {
                adjustContentPosition(tabState, stateType);
            }, 0, false);
        };

        function isTabActive(tabId) {
            return $(prefix.hashbangPrefix + tabId).hasClass(cssClass.active);
        };

        function closeOpenedTabIfNoPrivilege(tabStateType) {
            var tabState = localStorageService.getItem(tabStateType);
            if (tabState != undefined) {
                angular.element(prefix.hashbangPrefix + tabState).removeClass(cssClass.active);
                var tabElement = angular.element(prefix.hashbangPrefix + tabState + ' a');
                if (tabElement && tabElement.attr('href')) {
                    var activePanel = tabElement.attr('href').replace(prefix.hashbangPrefix, '');
                    angular.element(prefix.hashbangPrefix + activePanel).removeClass(cssClass.active);
                }
            }
        };

        function adjustContentHeightHomeStartPageTab() {
            var heightDocument = $(document).height();
            var height = heightDocument - 120;
            angular.element('.home-content .homme-tab1').css({
                height: height
            });
        };

        /*Adjust content position when loading page*/
        function adjustContentPosition(tabId, stateType, showmoreItem, newHeight) {
            if (stateType == tabStateType.chapterTabState) {
                var documentHeight = $(document).height();
                var heightOfTopUserBar = $('#handbook-nav').height();
                var heightOfChapterTabs = $('.page-container_header').first().height();

                var activeTabs = $('#chaptertabcontent .tab-pane.active');
                var heightTabActive = (activeTabs != null && activeTabs != undefined) ? activeTabs.children().first().height() : 0;

                var heightOfChapterContent = newHeight != undefined ? newHeight : (heightTabActive - 30);

                var searchInfolderContainer = $('#searchInfolderContainer');
                var searchInFolderNotActive = searchInfolderContainer.hasClass('ng-hide');
                var chapterWhatsNewNotActive = $('#chapter-whats-new-content').hasClass('ng-hide');
                var leftPanelOfChapter = searchInFolderNotActive ? $('#topmenuleftid') : $('#searchInfolderContainer #topmenuleftid');
                var rightPanelOfChapter = searchInFolderNotActive ? $('#topmenurightid') : $('#searchInfolderContainer #topmenurightid');

                var heightOfChapterPanels = 0;
                var heightOfStuffElements = 0;

                if (leftPanelOfChapter.position() && rightPanelOfChapter.position()) {
                    if (leftPanelOfChapter.position().top == rightPanelOfChapter.position().top) {
                        heightOfChapterPanels = leftPanelOfChapter.outerHeight();
                    } else {
                        heightOfChapterPanels = leftPanelOfChapter.outerHeight() + rightPanelOfChapter.outerHeight();
                    }
                }

                if (msieversion() >= 7 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || isSafari()) {
                    heightOfStuffElements = !searchInFolderNotActive ? 40 : (!chapterWhatsNewNotActive ? 68 : 90);
                } else {
                    heightOfStuffElements = !searchInFolderNotActive ? 30 : (!chapterWhatsNewNotActive ? 58 : 80);
                }

                var folderContentHeight = documentHeight - heightOfTopUserBar
                    - heightOfChapterTabs
                    - heightOfChapterContent
                    - heightOfChapterPanels
                    - heightOfStuffElements;
                adjustContentHeightOnDevices(folderContentHeight);
            } else if (stateType == tabStateType.documentTabState) {
                var hearingFeedbackPage = $('.hearing-feedback-page');
                if (hearingFeedbackPage.length > 0) {
                    var activeTabs = $('.tab-pane.active');
                    var heightTabActive = (activeTabs != null && activeTabs != undefined) ? activeTabs.children().first().height() : 0;
                    var newHeight = constantValues.documentTabContentMinTop + heightTabActive;
                    var myAssessment = $('#myAssessment');
                    var heightMyAssessment = myAssessment != undefined ? myAssessment.height() + 30 : 65;
                    height = $(document).height() - newHeight - heightMyAssessment;
                    //angular.element('#' + documentContent.content + '').css({ height: height });
                } else {
                    var top = 0;
                    if (tabId == documentTabs.about) {
                        var aboutTab = angular.element('#' + tabContents.about + '');
                        top = aboutTab.height() != null ? aboutTab.height() + aboutTab.position().top : 0;
                    } else if (tabId == documentTabs.content) {
                        var contentTab = angular.element('#' + tabContents.content + '');
                        // for DocumentField does not have content tab, so we need to check null before getting value
                        if (contentTab.length > 0) {
                            top = contentTab.height() + contentTab.position().top;
                        }
                    } else if (tabId == documentTabs.readingReceipt) {
                        var readingTab = angular.element('#' + tabContents.readingReceipt + '');
                        top = readingTab.height() != null ? readingTab.height() + readingTab.position().top : 0;
                    } else if (tabId == documentTabs.feedback) {
                        var feedbackTab = angular.element('#' + tabContents.feedback + '');
                        top = feedbackTab.height() != null ? feedbackTab.height() + feedbackTab.position().top : 0;
                    } else if (tabId == documentTabs.search) {
                        var searchInContentTab = angular.element('#' + tabContents.search + '');
                        top = searchInContentTab.height() != null ? searchInContentTab.height() + searchInContentTab.position().top : 0;
                    } if (tabId == documentTabs.hearing) {
                        var searchInContentTab = angular.element('#' + tabContents.hearing + '');
                        top = searchInContentTab.height() != null ? searchInContentTab.height() + searchInContentTab.position().top : 0;
                    }
                    if (top <= 0) {
                        top = constantValues.documentTabContentMinTop + 10;
                    } else {
                        top = top + 10;
                    }

                    var topMenuTop = 0;
                    if (angular.element('.topmenu-right-panel').position()) {
                        topMenuTop = angular.element('.topmenu-right-panel').position().top;
                    }
                    var addHeight = 10;
                    if ($(document).width() > 600)
                        addHeight = 27;
                    var height = $(document).height() - top - constantValues.topMenuHeight - topMenuTop + addHeight;

                    var extendDocumentNotification = angular.element(".extend-document-notification").height();
                    if (!extendDocumentNotification)
                        extendDocumentNotification = 0;

                    heightContentDocument = (height + 25);
                    //angular.element('#' + documentContent.content + '').css({
                    //    height: (height + 25 - extendDocumentNotification)
                    //});
                }

            } else if (stateType == tabStateType.homeTabState) {
                if (tabId == homeTabs.whatNew) {
                    setTimeout(() => {
                        var newsContainer = angular.element(".container-news-tab").height();
                        var newsTab = angular.element(".header-item-bar").height();

                        angular.element('#whatNewContainer #gridController').css({ height: newsContainer - newsTab - 30 });
                    }, 200);
                } else if (tabId == homeTabs.updatedFavorite) {
                    setTimeout(() => {
                        var favContainer = angular.element(".container-favorite-tab").height();
                        var favTab = angular.element(".header-item-bar").height();

                        angular.element('#updatedFavoriteContainer #gridController').css({ height: favContainer - favTab - 70 });
                    }, 200);
                } else if (tabId == homeTabs.readingListTab) {
                    setTimeout(() => {
                        var readingContainer = angular.element(".container-readings-tab").height();
                        var readingListHeader = angular.element(".reading-list-header").height();
                        var readingTab = angular.element("#reading-list-tabs").height();

                        angular.element('#reading-list-tab1 #gridController').css({ height: readingContainer - readingTab - 30 });
                        angular.element('#reading-list-tab2').css({ height: readingContainer - readingTab - readingListHeader - 123 });
                        angular.element('#reading-list-tab3 #gridController').css({ height: readingContainer - readingTab - 75 });
                    }, 200);

                } else if (tabId == homeTabs.hearingTab) {
                    setTimeout(() => {
                        var hearingContainer = angular.element(".container-hearings-tab").height();
                        var hearingTab = angular.element("#document-hearings-tabs").height();
                        angular.element('#hearings-tab1 #gridController').css({ height: hearingContainer - hearingTab - 125 });
                        angular.element('#hearings-tab2 #gridController').css({ height: hearingContainer - hearingTab - 125 });
                    }, 200);
                }
            }
        }

        function adjustContentHeightOnDevices(contentHeight) {
            var newContent = $('#chapter-whats-new-content').height();
            var searchContent = $('#searchInfolderContainer').height();
            var gridDocumentQueryByClassName = '.' + folderContent.gridDocumentClass + '';

            if (newContent) {
                angular.element('#' + folderContent.content + '').css({ height: contentHeight - 30 });
            }
            else if (searchContent) {
                angular.element('#' + folderContent.content + '').css({ height: contentHeight - 10 });
            } else {
                angular.element('#' + folderContent.content + '').css({ height: contentHeight - 150 });
            }

            //angular.element(gridDocumentQueryByClassName).css({ 'max-height': (contentHeight - 54) });
        }

        /*Adjust content height when user click on tab.*/
        function adjustContentHeightPosition(stateType, newHeight) {
            switch (stateType) {
                case tabStateType.documentTabState:
                    var hearingFeedbackPage = $('.hearing-feedback-page');
                    var documentTabActive = localStorageService.getItem(tabStateType.documentTabState);
                    var documentHeight = $(document).height();
                    var documentWidth = $(document).width();
                    var availWidth = screen.availWidth;
                    var availHeight = screen.availHeight;
                    var height = 0;
                    if (hearingFeedbackPage.length > 0) {
                        var activeTabs = $('.tab-pane.active');
                        var heightTabActive = (activeTabs != null && activeTabs != undefined) ? activeTabs.children().first().height() : 0;
                        if (newHeight > 0) {
                            newHeight = constantValues.documentTabContentMinTop + newHeight;
                        } else {
                            newHeight = constantValues.documentTabContentMinTop + heightTabActive;
                        }
                        var myAssessment = $('#myAssessment');
                        var heightMyAssessment = myAssessment != undefined ? myAssessment.height() + 30 : 65;
                        height = documentHeight - newHeight - heightMyAssessment;
                        angular.element('#' + documentContent.content + '').css({ height: height });
                        var heightOfTitle = $('#documentFieldListName') ? $('#documentFieldListName').height() : 30;
                        angular.element('#documentDetailFieldContentList').css({
                            maxHeight: (height - 125 - heightOfTitle)
                        })
                    } else {
                        if (angular.element('#handbook-nav:visible').length != 0) {
                            var searchHeaderHeight = 0;
                            var topMenuTop = $('#document-top-menu-identifier').height() || 0;

                            if ($('#SearchHeaderMobile').position()) {
                                searchHeaderHeight = $('#SearchHeaderMobile').position().top + 76;
                            }
                            var addHeight = 27;
                            if ((availHeight == 768 && availWidth == 1024)) {
                                addHeight = 10;
                            }

                            var extendDocumentNotification = angular.element(".extend-document-notification").height();
                            if (!extendDocumentNotification)
                                extendDocumentNotification = 0;

                            if (documentWidth > 600) {
                                if (documentTabActive) {
                                    if (newHeight > 0) {
                                        newHeight = constantValues.documentTabContentMinTop + newHeight;
                                    } else {
                                        var docContent = angular.element(".document-content").height();
                                        newHeight = constantValues.documentTabContentMinTop + docContent + 40;
                                    }
                                    height = documentHeight - newHeight - constantValues.topMenuHeight - topMenuTop + addHeight;
                                } else {
                                    height = documentHeight - 47 - constantValues.topMenuHeight - topMenuTop;
                                }
                                var extendHeight = extendDocumentNotification ? 0 : extendDocumentNotification;
                                angular.element('#' + documentContent.content + '').css({
                                    height: (height + 42 - extendHeight - searchHeaderHeight)
                                });

                                var heightOfTitle = $('#documentFieldListName') ? $('#documentFieldListName').height() : 30;
                                angular.element('#documentDetailFieldContentList').css({
                                    maxHeight: (height - 155 - heightOfTitle)
                                })
                            } else {
                                if (documentTabActive) {
                                    if (newHeight > 0) {
                                        newHeight = mobileConstantValues.documentTabContentMinTop + newHeight + 20;
                                    } else {
                                        newHeight = mobileConstantValues.documentTabContentMinTop + 20;
                                    }
                                    height = documentHeight - newHeight - mobileConstantValues.topMenuHeight - topMenuTop;
                                } else {
                                    height = documentHeight - 60 - mobileConstantValues.topMenuHeight - topMenuTop;
                                }
                                angular.element('#' + documentContent.content + '').css({ height: (height - extendDocumentNotification - searchHeaderHeight) });
                                var heightOfTitle = $('#documentFieldListName') ? $('#documentFieldListName').height() : 30;
                                angular.element('#documentDetailFieldContentList').css({
                                    maxHeight: (height - 130 - heightOfTitle)
                                })
                            }
                        }
                    }
                    heightContentDocument = height;
                    var element = $location.url().split('/');
                    if (element[3] != 'fields' && element[3] != 'hearingfields') {
                        setTimeout(function () { documentService.stickyTitle(); }, 500);
                    }
                    break;
                case tabStateType.chapterTabState:
                    adjustContentPosition(null, tabStateType.chapterTabState, null, newHeight - 30);
                    break;
            }
        };

        function adjustFolderContentIdentifierHeight() {
            let windowHeight = $(window).height();
            let topToFolderContentIdentifierHeight = 0;
            let goToTopOrTotalDocumentHeight = 17;

            if ($('#folder-content-identifier')) {
                topToFolderContentIdentifierHeight = $('#folder-content-identifier').position().top;
            }

            let newHeight = windowHeight - topToFolderContentIdentifierHeight - goToTopOrTotalDocumentHeight;
            angular.element('#folder-content-identifier').css({
                height: newHeight
            });

            //if ($('#gridController')) {
            //    angular.element('#gridController').css({
            //        maxHeight: '100%'
            //    });
            //}
        }
    };

    function updateHeightForCompendiaDocuments() {
        var documentHeight = $(document).height();
        var topbarHeight = $('#navbar-header').height();
        var searchResultPageHeight = $('.search-result-page').height(); //83
        var handbookHintsHeight = $('.tabbable > .search-hit').height(); //68
        var handbookDocumentsHeight = $('.tabbable > .scrollable-y').height();//410
        var compendiaSearchHeight = $('.compendia-search').height();//68
        var compendiaDocumentsHeight = documentHeight
            - (topbarHeight + searchResultPageHeight + handbookHintsHeight + handbookDocumentsHeight + compendiaSearchHeight)
            - 130;

        $('.compendia-documents .content-wrapper').css({ height: compendiaDocumentsHeight });
    }

    //browserService
    function browserService() {
        var service = {
            historyManipulationSupported: historyManipulationSupported,
            detectBrowserWindow: detectBrowserWindow
        };

        return service;

        function historyManipulationSupported() {
            return window.history && window.history.pushState != undefined;
        }

        function detectBrowserWindow() {
            var browserType = BrowserType.PC;
            var screenW = window.innerWidth;
            if (screenW > 1024)
                browserType = BrowserType.PC;
            else if (768 <= screenW && screenW <= 1024)
                browserType = BrowserType.TABLET;
            else
                browserType = BrowserType.MOBILE;
            return browserType;
        }
    };

    //anchorService
    anchorService.$inject = ['$location', 'browserService', 'broadcastService'];
    function anchorService($location, browserService, broadcastService) {

        var anchorObject = {
            position: 0
        };

        var service = {
            updateLocalAnchors: updateLocalAnchors,
            setAnchorObject: setAnchorObject,
            getAnchorObject: getAnchorObject
        };

        return service;

        function updateLocalAnchors(text, addClick) {
            // If browser does not support history manipulation, then hashbang (#!) is used 
            // and the relative url will work properly with anchors already because base url will always stay the same
            var historyManipulationSupported = browserService.historyManipulationSupported();

            angular.forEach(text.find('a[href]'), function (tag, addClick) {
                addAnchorEvent(tag, historyManipulationSupported);
            });

            angular.forEach(text.find('area[href]'), function (tag, addClick) {
                addAnchorEvent(tag, historyManipulationSupported);
            });

            return text;
        };

        function addAnchorEvent(tag, historyManipulationSupported) {
            if (tag.attributes.href.value.indexOf('#') == 0) //local anchor tag
            {
                if (historyManipulationSupported) {
                    var anchorValue = tag.attributes.href.value;
                    tag.href = $location.path() + window.location.search + anchorValue;
                }

                tag.addEventListener('click', function (e) {
                    var documentContent = angular.element('#document-content-identifier'),
                        folderContent = angular.element('#folder-content-identifier'),
                        newsContent = angular.element('#wrapper');
                    var position = 0;
                    if (documentContent && documentContent.length > 0) {
                        position = documentContent[0].scrollTop;
                    } else if (folderContent && folderContent.length > 0) {
                        position = folderContent[0].scrollTop;
                    } else if (newsContent && newsContent.length > 0) {
                        position = newsContent[0].scrollTop;
                    }
                    anchorObject.position = position;
                    broadcastService('anchorclick', { hash: e.target.hash });
                });
            }
            // For some reason the anchor only works once without target self (most likely because of angular https://github.com/angular/angular.js/issues/4608)
            // Add target for all the a[href] without target
            if (tag.target == '' || tag.target == undefined) {
                tag.target = '_self';
            }
        };

        function setAnchorObject(position) {
            anchorObject.position = position;
        };

        function getAnchorObject() {
            return anchorObject;
        };
    };

    //feedBackService
    feedBackService.$inject = ['$http'];
    function feedBackService($http) {
        var service = {
            sendFeedback: sendFeedback
        };

        return service;

        function sendFeedback(entityId, data) {
            var request = {
                entityId: entityId,
                positive: data.positive,
                feedbackMessage: data.feedbackMessage,
                feedBack: data.feedBack,
                sendAlsoToApprover: data.sendAlsoToApprover
            };
            return $http.post(handbookRequests.SubmitFeedbackRequest, request)
                .then(function (data, status, headers, config) {
                    return true;
                });
        };
    };

    //readingConfirmationService
    readingConfirmationService.$inject = ['$http'];
    function readingConfirmationService($http) {
        var service = {
            GetConfirmInformation: getConfirmInformation,
            sendReadingConfirmation: sendReadingConfirmation
        };

        return service;

        function getConfirmInformation(entityId) {
            return $http.get(handbookRequests.GetDocumentConfirmInformationRequest,
                {
                    params: { 'entityId': entityId }
                }).then(function (data, status, headers, config) {
                    return data;
                });
        };

        function sendReadingConfirmation(entityId, folderId) {
            return $http.post(handbookRequests.SubmitReadConfirmRequest, { 'entityId': entityId, 'folderId': folderId })
                .then(function (data, status, headers, config) {
                    return data.data;
                });
        };
    };

    //debounceService
    function debounceService() {
        var service = {
            debounce: debounce
        };

        return service;

        function debounce(fn, delay) {
            var timer = null;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    fn.apply(context, args);
                }, delay || 500);
            };
        };
    };

    //documentTemplateService
    documentTemplateService.$inject = ['$http'];
    function documentTemplateService($http) {
        var documentTemplate = [];
        var service = {
            getDocumentTemplate: getDocumentTemplate,
            getDocumentTemplateNameById: getDocumentTemplateNameById
        };

        return service;

        function getDocumentTemplate() {
            return $http.get(handbookRequests.GetDocumentTemplateRequest)
                .then(function (response, status, headers, config) {
                    documentTemplate = response.data;
                    return response.data;
                });
        };

        function getDocumentTemplateNameById(id) {
            var templateName = '';
            for (var index = 0; index < documentTemplate.length; index++) {
                if (documentTemplate[index].id == id) {
                    templateName = documentTemplate[index].name;
                    break;
                }
            }
            return templateName;
        };
    };

    //resizeService
    function resizeService() {
        var service = {
            resizeView: resizeView,
            resizeToOrginalSize: resizeToOrginalSize,
            resizeToChangedSize: resizeToChangedSize
        };
        return service;

        function resizeView() {
            var currentSideBarWidth = angular.element(elementId.sidebarWrapper).width();
            if (currentSideBarWidth > 320) {
                var screenWidth = window.innerWidth;
                angular.element(elementClass.tabTable).css({
                    'padding-left': (currentSideBarWidth - 320) + 'px'
                });

                angular.element(elementClass.frontPageCustomArea).css({
                    'padding-left': (currentSideBarWidth - 320) + 'px'
                });

                angular.element('#document-content-information-id').css({
                    'padding-left': (currentSideBarWidth - 320) + 'px'
                });
            }
        };

        function resizeToOrginalSize() {
            angular.element(elementId.sidebarWrapper).removeAttr('style');
            angular.element(elementId.reSizeBar).removeAttr('style');
            angular.element(elementClass.tabTable).removeAttr('style');
            angular.element('#document-content-information-id').removeAttr('style');
            angular.element(elementClass.frontPageCustomArea).removeAttr('style');
            angular.element('.sidebar-brand').removeAttr('style');
        };

        function resizeToChangedSize(width, isCompare) {
            if (!isCompare) {
                angular.element(elementId.sidebarWrapper).css({
                    'width': width + 'px'
                });
                angular.element('.sidebar-brand').css({
                    'width': width + 'px'
                });

                angular.element(elementId.reSizeBar).css({
                    'width': (width + 8) + 'px',
                    'z-index': 999
                });

                var screenWidth = window.innerWidth;
                if (screenWidth > 980) {
                    angular.element(elementClass.tabTable).css({
                        'padding-left': (width - 320) + 'px'
                    });

                    angular.element(elementClass.frontPageCustomArea).css({
                        'padding-left': (width - 320) + 'px'
                    });

                    angular.element('#document-content-information-id').css({
                        'padding-left': (width - 320) + 'px'
                    });
                }
            } else {
                var screenWidth = $(document).width();
                width = width > 320 ? width : 320;
                width = (screenWidth - width) < 200 ? screenWidth - 210 : width;
                angular.element('.comparison-result').css({
                    'width': width + 'px'
                });

                angular.element('#resizeBar').css({
                    'width': (width + 8) + 'px',
                    'z-index': 999
                });

                angular.element('.comparison-versions').css({
                    'width': (screenWidth - width - 40) + 'px',
                    'padding-right': 0
                });
            }
        };
    };

    //stringValidationService
    function stringValidationService() {
        var service = {
            notContainSpecialCharacter: notContainSpecialCharacter
        };
        return service;

        function notContainSpecialCharacter(keyword) {
            var re = '^([ a-zA-Z0-9.\_\\-/\WåøæÅØÆ"])*$',
                regExp = new RegExp(re, 'gi');
            return regExp.test(keyword);
        };
    };

    //newsService
    newsService.$inject = ['$http'];
    function newsService($http) {
        var service = {
            getNews: getNews,
            getActiveNewsById: getActiveNewsById,
            getNewsWithPaging: getNewsWithPaging,
            updateNewsReadCount: updateNewsReadCount,
            adjustNewsHeight: adjustNewsHeight,
            getNewsByCategoryId: getNewsByCategoryId,
            getNewsImageById: getNewsImageById
        };

        return service;

        function getNews(filter) {
            return $http.get(handbookRequests.GetNewsOnStarpage, { params: filter });
        };

        function getActiveNewsById(id) {
            return $http.get(handbookRequests.GetActiveNewsById, { params: { id: id } });
        };

        function getNewsWithPaging(pageIndex, pageSize) {
            return $http.get(handbookRequests.GetNewsWithPaging, { params: { pageIndex: pageIndex, pageSize: pageSize } });
        };

        function updateNewsReadCount(id) {
            var requestUrl = handbookRequests.UpdateNewsReadCount + '/' + id;
            return $http.post(requestUrl);
        };

        function getNewsByCategoryId(categoryId, showInModule, pageIndex, pageSize) {
            return $http.get(handbookRequests.GetNewsByCategoryId, { params: { categoryId: categoryId, showInModule: showInModule, pageIndex: pageIndex, pageSize: pageSize } });
        };

        function adjustNewsHeight() {
            var availWidth = screen.availWidth;
            var availHeight = screen.availHeight;

            // if ((availWidth <= 414 && availHeight <= 736) || (availHeight <= 414 && availWidth <= 736)) {
            //    var $newsHeaders = angular.element('.news-item > a > h4');
            //    var height = 0;
            //    var heightTitle = 0;
            //    for (var i = 0; i < $newsHeaders.length; i++) {
            //        var line = $newsHeaders.eq(i).getLines();
            //        heightTitle = (line > 6 ? 0 : line) * 15;
            //        var ingressHeight = $newsHeaders.eq(i).parent().siblings().find('div.news-content > p').height();
            //        var imageHeight = 0;
            //        var objectImage = $newsHeaders.eq(i).parent().siblings().find('div.news-content > a > img');
            //        if (objectImage != null && objectImage != undefined) {
            //            imageHeight = objectImage.height();
            //        }
            //        if (heightTitle > 0) {
            //            height = (ingressHeight > imageHeight ? ingressHeight : imageHeight) + heightTitle + 52;
            //            angular.element('#news' + i).css({ height: height });
            //        } else {
            //            angular.element('#news' + i).css({ height: 200 });
            //        }
            //    }
            // } else {
            //    var $newsHeaders = angular.element('.news-item > a > h4');
            //    var height = 0, maxHeight = 0;
            //    var heightTitle = 0, maxHeightTitle = 0;
            //    for (var i = 0; i < $newsHeaders.length; i++) {
            //        var line = $newsHeaders.eq(i).getLines();
            //        heightTitle = (line > 6 ? 0 : line) * 15;
            //        maxHeightTitle = maxHeightTitle < heightTitle ? heightTitle : maxHeightTitle;
            //        var ingressHeight = $newsHeaders.eq(i).parent().siblings().find('div.news-content > p').height();
            //        var imageHeight = 0;
            //        var objectImage = $newsHeaders.eq(i).parent().siblings().find('div.news-content > a > img');
            //        if (objectImage != null && objectImage != undefined) {
            //            imageHeight = objectImage.height();
            //        }
            //        if (heightTitle > 0) {
            //            height = (ingressHeight > imageHeight ? ingressHeight : imageHeight) + maxHeightTitle + 52;
            //        }
            //        if (maxHeight < height) {
            //            maxHeight = height;
            //        }
            //    }
            //    if (maxHeight == 0) {
            //        maxHeight = 250;
            //    }
            //    if (maxHeightTitle != 0) {
            //        angular.element('.news-item > a > h4').css({ height: maxHeightTitle });
            //    }
            //    angular.element('.news-group > div.news-item').css({ height: maxHeight });
            // }
        };

        function getNewsImageById(newsId) {
            return $http.get(handbookRequests.GetNewsImageById, { params: { newsId: newsId } });
        };
    };

    //folderService
    folderService.$inject = ['$http'];
    function folderService($http) {
        var service = {
            getFolder: getFolder,
            getFolderById: getFolderById,
            setFolder: setFolder,
            getFolderByVirtualDocumentId: getFolderByVirtualDocumentId
        };

        return service;

        var folder;

        function getFolder() {
            return folder;
        };

        function getFolderById(id) {
            if (folder == null || folder == undefined || folder.id != id) {
                return $http.get(handbookRequests.GetFolderContentsRequest, { params: { 'folderId': id } })
                    .success(function (response, status, headers, config) {
                        return response;
                    })
            };
        };

        function setFolder(folderObject) {
            folder = folderObject;
        };

        function getFolderByVirtualDocumentId(id) {
            return $http.get(handbookRequests.GetFoldersByVirtualDocumentId, { params: { 'documentId': id } })
                .success(function (response, status, headers, config) {
                    return response;
                })
        };

    };

    //treeNavigationService
    treeNavigationService.$inject = ['$timeout', '$stateParams', '$http', 'broadcastService'];
    function treeNavigationService($timeout, $stateParams, $http, broadcastService) {
        var currentRecursiveIndex = 0;
        var parents = [];
        var currentTree = null;
        var nodeType = 0; // 0: folder, 1: document
        var isDocumentTree = false;

        var service = {
            navigateToCurrentItem: navigateToCurrentItem,
            onChildrenLoaded: onChildrenLoaded,
            setDocumentsTree: setDocumentsTree,
            changeRoute: changeRoute,
            setNodeType: setNodeType,
            navigateToItemLocation: navigateToItemLocation,
            scrollToVisibleView: scrollToVisibleView,
            setIsDocumentTree: setIsDocumentTree,
            getIsDocumentTree: getIsDocumentTree
        };

        return service;

        function navigateToItemLocation(navigateSideBar, isClick) {
            if (HandbookConfiguration.AutoHighlightInTree.toUpperCase() == "TRUE" || isClick == true) {
                $timeout(function () {
                    broadcastService(broadcastType.collapseExpandSidebar, {
                        navigateSideBar: navigateSideBar
                    });
                }, 0);
            }
        }

        function navigateToCurrentItem(items, recursives, isScroll) {
            if (!recursives || recursives.length == 0) {
                return;
            }
            parents = recursives;
            for (var j = 0; j < items.length; j++) {
                if (items[j].id == recursives[currentRecursiveIndex].id) {
                    var index = j;
                    $timeout(function () {
                        if (currentRecursiveIndex == (recursives.length - 1)) {
                            angular.element('#treeDocuments .selected:not(#' + items[index].id + '-label)').removeClass('selected');
                            if (nodeType == treeNodeTypes.document) {
                                var node = angular.element('#treeDocuments #' + items[index].id + '-collapsed');
                                if (!node.hasClass('ng-hide')) {
                                    node.trigger('click');
                                }
                                $timeout(function () {
                                    var nodeDoc = angular.element('#treeDocuments #' + $stateParams.documentId + '-' + items[index].id + '-label');
                                    if (!nodeDoc || nodeDoc.length == 0)
                                        nodeDoc = angular.element('#treeDocuments #' + items[index].id + '-label');
                                    if (nodeDoc && nodeDoc.length > 0) {
                                        nodeDoc.addClass('selected');
                                        if (isScroll) {
                                            scrollToVisibleView(nodeDoc);
                                        }
                                    }
                                }, 1000);
                            } else {
                                var node = angular.element('#treeDocuments #' + items[index].id + '-label-f');
                                if (node && node.length > 0) {
                                    node.addClass('selected');
                                    if (isScroll) {
                                        scrollToVisibleView(node);
                                    }
                                }
                            }
                            currentRecursiveIndex = 0;
                        } else {
                            var node = angular.element('#treeDocuments #' + items[index].id + '-collapsed');
                            currentRecursiveIndex += 1;
                            if (!node.hasClass('ng-hide')) {
                                node.trigger('click');
                                onChildrenLoaded(items[index], isScroll);
                            } else {
                                onChildrenLoaded(items[index], isScroll);
                            }
                        }
                    }, 0);
                }
            }
        }

        function getCurrentRecursiveIndex(nodeParent) {
            for (var i = 0; i < parents.length; i++) {
                if (nodeParent.id == parents[i].id) {
                    if (i < parents.length - 1) {
                        return i + 1;
                    } else {
                        return i;
                    }
                }
            }

            return parents.length - 1;
        }

        function onChildrenLoaded(node, isScroll) {
            if (parents == null || parents == undefined || parents.length == 0)
                return;

            currentRecursiveIndex = getCurrentRecursiveIndex(node);
            if (currentRecursiveIndex >= parents.length)
                return;
            if (node.children == null || node.children.length <= 0)
                return;

            var items = node.children;
            for (var i = 0; i < items.length; i++) {
                if (items[i].id != parents[currentRecursiveIndex].id)
                    continue;

                var index = i;
                if (currentRecursiveIndex == (parents.length - 1)) { // it's current folder/document
                    $timeout(function () {
                        angular.element('#treeDocuments .selected:not(#' + items[index].id + '-label)').removeClass('selected');
                        if (nodeType == treeNodeTypes.document) {
                            var node = angular.element('#treeDocuments #' + items[index].id + '-collapsed');
                            if (!node.hasClass('ng-hide')) {
                                node.trigger('click');
                            }
                            $timeout(function () {
                                var nodeDoc = angular.element('#treeDocuments #' + $stateParams.documentId + '-' + items[index].id + '-label');
                                if (!nodeDoc || nodeDoc.length == 0)
                                    nodeDoc = angular.element('#treeDocuments #' + items[index].id + '-label');
                                if (nodeDoc && nodeDoc.length > 0) {
                                    nodeDoc.addClass('selected');
                                    if (isScroll) {
                                        scrollToVisibleView(nodeDoc);
                                    }
                                }
                            }, 1000);
                        } else {
                            var node = angular.element('#treeDocuments #' + items[index].id + '-label-f');
                            if (node && node.length > 0) {
                                node.addClass('selected');
                                if (isScroll) {
                                    scrollToVisibleView(node);
                                }
                            }
                        }
                    });
                    currentRecursiveIndex = 0;
                    break;
                }

                currentRecursiveIndex += 1;
                $timeout(function () {
                    var node = angular.element('#treeDocuments #' + items[index].id + '-collapsed');
                    if (!node.hasClass('ng-hide')) {
                        node.trigger('click');
                        onChildrenLoaded(items[index], isScroll);
                    } else {
                        onChildrenLoaded(items[index], isScroll);
                    }
                }, 0);

                break;
            }

        }

        function scrollToVisibleView(node) {
            var offset = 0;
            var nodeOffset = node.offset();
            if (nodeOffset) {
                offset = nodeOffset.top;
            }
            var $parentDiv = $('#sidebar-wrapper').first();
            var visible_area_start = $parentDiv.offset().top;
            var visible_area_end = visible_area_start + $parentDiv.height();
            if (offset > (visible_area_end - 10) || offset < visible_area_start) {
                $parentDiv.animate({
                    scrollTop: $parentDiv.scrollTop() - visible_area_start + offset - 100
                }, 100);
            }
        }

        function setDocumentsTree(tree) {
            currentTree = tree;
        }

        function changeRoute() {
            currentRecursiveIndex = 0;
        }

        function setNodeType(type) {
            nodeType = type;
        }

        function setIsDocumentTree(flag) {
            isDocumentTree = flag;
        }

        function getIsDocumentTree() {
            return isDocumentTree;
        }

    };

    //routeService
    routeService.$inject = ['$timeout'];
    function routeService($timeout) {
        var previousRoute = { itemId: 0, itemType: '' };

        var service = {
            setRoute: setRoute,
            getRoute: getRoute,
            getBaseRouteProcess: getBaseRouteProcess,
            getDashboardBaseRoute: getDashboardBaseRoute
        };

        return service;

        function setRoute(route) {
            previousRoute = route;
        }

        function getRoute() {
            return previousRoute;
        }

        function getBaseRouteProcess() {
            return window.location.origin + '/process/';
            // return 'http://localhost:4200/process/';
        }

        function getDashboardBaseRoute() {
            return window.location.origin + '/dashboard/';
        }
    };

    //metaData
    metaDataService.$inject = ['$http', '$q'];
    function metaDataService($http, $q) {
        var service = {
            getRegisterItems: getRegisterItems,
            getMetadataTags: getMetadataTags,
            getMetaRegisters: getMetaRegisters,
            getActiveMetaRegisters: getActiveMetaRegisters,
            getRegisterAndRegisterItems: getRegisterAndRegisterItems
        };

        return service;

        function getRegisterItems(registerId) {
            return $http.get(handbookRequests.GetRegisterItemsRequest, { params: { 'registerId': registerId } })
                .then(function (response, status, headers, config) {
                    return response.data;
                });
        };

        function getRegisterAndRegisterItems() {
            return $http.get(handbookRequests.GetRegisterAndRegisterItems, {})
                .then(function (response, status, headers, config) {
                    return response.data;
                });
        };

        function getMetadataTags(registerItemId) {
            return $http.get(handbookRequests.GetMetadataTagsRequest, { params: { 'registerItemId': registerItemId } })
                .then(function (response, status, headers, config) {
                    return response.data;
                });
        };

        function getMetaRegisters() {
            return $http.get(handbookRequests.GetMetaRegistersRequest, {})
                .then(function (response, status, headers, config) {
                    return response.data;
                });
        };

        function getActiveMetaRegisters() {
            return $http.get(handbookRequests.GetActiveMetaRegistersRequest, {})
                .then(function (response, status, headers, config) {
                    return response.data;
                });
        };

    };

    shortcutKeysService.$inject = ['$state', '$http', '$timeout', 'tabStateService', 'broadcastService'];
    function shortcutKeysService($state, $http, $timeout, tabStateService, broadcastService) {
        var shortcuts = {
        };
        getShortcuts();
        var service = {
            gotoStartpage: {
                shortcut: shortcuts.gotoStartpage,
                method: gotoStartpage
            },
            openFavouritesMenu: {
                shortcut: shortcuts.openFavouritesMenu,
                method: openFavouritesMenu
            },
            openDocumentsMenu: {
                shortcut: shortcuts.openDocumentsMenu,
                method: openDocumentsMenu
            },
            openSimpleSearch: {
                shortcut: shortcuts.openSimpleSearch,
                method: openSimpleSearch
            },
            navigateItemInSidebar: {
                shortcut: shortcuts.navigateItemInSidebar,
                method: navigateItemInSidebar
            },
            printFolderPDFIndex: {
                shortcut: shortcuts.printPDFIndex,
                method: printFolderPDFIndex
            },
            toggleFavorite: {
                shortcut: shortcuts.toggleFavorite,
                method: toggleFavorite
            },
            toggleEmailNotification: {
                shortcut: shortcuts.toggleEmailNotification,
                method: toggleEmailNotification
            },
            toggleOnlyFolderEmailNotification: {
                shortcut: shortcuts.toggleOnlyFolderEmailNotification,
                method: toggleOnlyFolderEmailNotification
            },
            openGridSetting: {
                shortcut: shortcuts.openGridSetting,
                method: openGridSetting
            },
            toggleFolderContentTab: {
                shortcut: shortcuts.toggleFolderContentTab,
                method: toggleFolderContentTab
            },
            toggleFolderAboutTab: {
                shortcut: shortcuts.toggleFolderAboutTab,
                method: toggleFolderAboutTab
            },
            openDocumentReadingReceipt: {
                shortcut: shortcuts.openDocumentReadingReceipt,
                method: openDocumentReadingReceipt
            },
            openDocumentFeedback: {
                shortcut: shortcuts.openDocumentFeedback,
                method: openDocumentFeedback
            },
            printDocumentPDFA4: {
                shortcut: shortcuts.printPDFIndex,
                method: printDocumentPDFA4
            },
            toggleDocumentFullScreenViewing: {
                shortcut: shortcuts.toggleDocumentFullScreenViewing,
                method: toggleDocumentFullScreenViewing
            },
            toggleDocumentContentTab: {
                shortcut: shortcuts.toggleFolderContentTab,
                method: toggleDocumentContentTab
            },
            toggleDocumentAboutTab: {
                shortcut: shortcuts.toggleFolderAboutTab,
                method: toggleDocumentAboutTab
            },
            toggleDocumentMetadataTab: {
                shortcut: shortcuts.toggleDocumentMetadataTab,
                method: toggleDocumentMetadataTab
            },
            toggleDocumentSearchInContentTab: {
                shortcut: shortcuts.toggleDocumentSearchInContentTab,
                method: toggleDocumentSearchInContentTab
            },
            toggleMasterHomeTab: {
                shortcut: shortcuts.toggleFolderContentTab,
                method: toggleMasterHomeTab
            },
            toggleWhatsNewsTab: {
                shortcut: shortcuts.toggleFolderAboutTab,
                method: toggleWhatsNewsTab
            },
            toggleUpdatedFavoriteTab: {
                shortcut: shortcuts.toggleDocumentMetadataTab,
                method: toggleUpdatedFavoriteTab
            },
            toggleMyReadingListTab: {
                shortcut: shortcuts.toggleDocumentSearchInContentTab,
                method: toggleMyReadingListTab
            },
            linkToDocumentManagement: {
                shortcut: shortcuts.linkToDocumentManagement,
                method: linkToDocumentManagement
            },
            linkToFolderManagement: {
                shortcut: shortcuts.linkToDocumentManagement,
                method: linkToFolderManagement
            }
        };

        return service;

        function gotoStartpage() {
            $state.go(handbookActions.HomeAction);
        };

        function getShortcuts() {
            // Opera 8.0+
            //var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
            // Firefox 1.0+
            var isFirefox = typeof InstallTrigger !== 'undefined';
            //// At least Safari 3+: "[object HTMLElementConstructor]"
            //   var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
            //// Internet Explorer 6-11
            //   var isIE = /*@cc_on!@*/false || !!document.documentMode;
            //// Edge 20+
            //   var isEdge = !isIE && !!window.StyleMedia;
            // Chrome 1+
            var isChrome = !!window.chrome && !!window.chrome.webstore;
            // Blink engine detection
            //var isBlink = (isChrome || isOpera) && !!window.CSS;
            shortcuts.gotoStartpage = 'ctrl+alt+h';
            shortcuts.openFavouritesMenu = 'ctrl+alt+f';
            shortcuts.openDocumentsMenu = 'ctrl+alt+d';
            shortcuts.openSimpleSearch = 'ctrl+alt+s';
            shortcuts.navigateItemInSidebar = 'ctrl+alt+n';
            shortcuts.printPDFIndex = 'ctrl+alt+p';
            shortcuts.toggleFavorite = 'ctrl+alt+a';
            shortcuts.toggleEmailNotification = 'ctrl+alt+e';
            shortcuts.openGridSetting = 'ctrl+alt+i';
            shortcuts.toggleFolderContentTab = 'ctrl+alt+1';
            shortcuts.toggleFolderAboutTab = 'ctrl+alt+2';
            shortcuts.openDocumentReadingReceipt = 'ctrl+alt+l';
            shortcuts.openDocumentFeedback = 'ctrl+alt+t';
            shortcuts.toggleDocumentFullScreenViewing = 'ctrl+alt+v';
            shortcuts.toggleDocumentMetadataTab = 'ctrl+alt+3';
            shortcuts.toggleDocumentSearchInContentTab = 'ctrl+alt+4';
            shortcuts.toggleOnlyFolderEmailNotification = 'ctrl+alt+m';
            shortcuts.linkToDocumentManagement = 'ctrl+alt+b';
        };

        function openFavouritesMenu() {
            broadcastService(broadcastType.onOpeningSidebarMenu, { menu: 'Favorites' });
        };

        function openDocumentsMenu() {
            broadcastService(broadcastType.onOpeningSidebarMenu, { menu: 'Document' });
        };

        function openSimpleSearch() {
            angular.element('.search-box').focus();
        };

        function navigateItemInSidebar() {
            broadcastService(broadcastType.collapseExpandSidebar, {
                navigateSideBar: true
            });
        };

        function printFolderPDFIndex() {
            broadcastService(broadcastType.printItemTarget, {
                printType: 4,
                itemType: 1 // 1: folder, 2: document
            });
        };

        function toggleFavorite() {
            broadcastService(broadcastType.toggleFavoriteTarget, {
                favoriteType: 1 // 1: folder, 2: document
            });
        };

        function toggleEmailNotification() {
            broadcastService(broadcastType.toggleEmailSubscriptionTarget, {});
        };

        function toggleOnlyFolderEmailNotification() {
            broadcastService(broadcastType.toggleOnlyFolderEmailSubscriptionTarget, {});
        };

        function linkToDocumentManagement() {
            broadcastService(broadcastType.linkToDocumentManagement, {});
        }

        function linkToFolderManagement() {
            broadcastService('linkToFolderManagement', {});
        }

        function openGridSetting() {
            broadcastService(broadcastType.toggleGridSettingTarget, {});
            $timeout(function () {
                var first = angular.element('#setting-box-main-contain input[type="checkbox"]')[0];
                first.focus();
            }, 200);
        };

        function toggleFolderContentTab() {
            activateTab('ChapterTabState', 'chapter-content');

            activateTabContent([{
                tabId: '#chapter-about',
                tabContentId: '.tab-content.chapter-content #tab2'
            }],
                {
                    tabId: '#chapter-content',
                    tabContentId: '.tab-content.chapter-content #tab1'
                });
        };

        function toggleFolderAboutTab() {
            activateTab('ChapterTabState', 'chapter-about');

            activateTabContent([{
                tabId: '#chapter-content',
                tabContentId: '.tab-content.chapter-content #tab1'
            }],
                {
                    tabId: '#chapter-about',
                    tabContentId: '.tab-content.chapter-content #tab2'
                });
        };

        function openDocumentReadingReceipt() {
            broadcastService(broadcastType.toggleReadingReceiptTarget, {});
            $timeout(function () {
                angular.element('#confirmReadContainer input[type="button"]')[0].focus();
            }, 200);
        };

        function openDocumentFeedback() {
            broadcastService(broadcastType.toggleDocumentFeedbackTarget, {});
            $timeout(function () {
                angular.element('#feedbackText')[0].focus();
            }, 200);
        };

        function printDocumentPDFA4() {
            broadcastService(broadcastType.printItemTarget, {
                printType: 1,
                itemType: 2 // 1: folder, 2: document
            });
        };

        function toggleDocumentFullScreenViewing() {
            broadcastService(broadcastType.toggleDocumentFullscreen, {});
        };

        function toggleDocumentContentTab() {
            activateTab('DocumentTabState', 'document-content');

            activateTabContent([{
                tabId: '#document-about',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier2'
            },
            {
                tabId: '#document-metadata',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier3'
            },
            {
                tabId: '#document-searchincontent',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier5'
            }],
                {
                    tabId: '#document-content',
                    tabContentId: '.tab-content.document-content.document-font #nav-tabs-identifier1'
                });
        };

        function toggleDocumentAboutTab() {
            activateTab('DocumentTabState', 'document-about');

            activateTabContent([{
                tabId: '#document-content',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier1'
            },
            {
                tabId: '#document-metadata',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier3'
            },
            {
                tabId: '#document-searchincontent',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier5'
            }],
                {
                    tabId: '#document-about',
                    tabContentId: '.tab-content.document-content.document-font #nav-tabs-identifier2'
                });
        };

        function toggleDocumentMetadataTab() {
            activateTab('DocumentTabState', 'document-metadata');

            activateTabContent([{
                tabId: '#document-content',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier1'
            },
            {
                tabId: '#document-about',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier2'
            },
            {
                tabId: '#document-searchincontent',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier5'
            }],
                {
                    tabId: '#document-metadata',
                    tabContentId: '.tab-content.document-content.document-font #nav-tabs-identifier3'
                });
        };

        function toggleDocumentSearchInContentTab() {
            activateTab('DocumentTabState', 'document-searchincontent');

            activateTabContent([{
                tabId: '#document-content',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier1'
            },
            {
                tabId: '#document-about',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier2'
            },
            {
                tabId: '#document-metadata',
                tabContentId: '.tab-content.document-content #nav-tabs-identifier3'
            }],
                {
                    tabId: '#document-searchincontent',
                    tabContentId: '.tab-content.document-content.document-font #nav-tabs-identifier5'
                });
        };

        function toggleMasterHomeTab() {
            activateTab('HomeTabState', 'master-tab');
            activateTabContent([{
                tabId: '#what-new-tab',
                tabContentId: '.tab-content.home-content #tab2'
            }, {
                tabId: '#favorite-tab',
                tabContentId: '.tab-content.home-content #tab3'
            }, {
                tabId: '#reading-list-tab',
                tabContentId: '.tab-content.home-content #tab4'
            }],
                {
                    tabId: '#master-tab',
                    tabContentId: '.tab-content.home-content #tab1'
                }, true);
        };

        function toggleWhatsNewsTab() {
            activateTab('HomeTabState', 'what-new-tab');
            activateTabContent([{
                tabId: '#master-tab',
                tabContentId: '.tab-content.home-content #tab1'
            }, {
                tabId: '#favorite-tab',
                tabContentId: '.tab-content.home-content #tab3'
            }, {
                tabId: '#reading-list-tab',
                tabContentId: '.tab-content.home-content #tab4'
            }],
                {
                    tabId: '#what-new-tab',
                    tabContentId: '.tab-content.home-content #tab2'
                }, true);
        };

        function toggleUpdatedFavoriteTab() {
            activateTab('HomeTabState', 'favorite-tab');
            activateTabContent([{
                tabId: '#master-tab',
                tabContentId: '.tab-content.home-content #tab1'
            }, {
                tabId: '#what-new-tab',
                tabContentId: '.tab-content.home-content #tab2'
            }, {
                tabId: '#reading-list-tab',
                tabContentId: '.tab-content.home-content #tab4'
            }],
                {
                    tabId: '#favorite-tab',
                    tabContentId: '.tab-content.home-content #tab3'
                }, true);
        };

        function toggleMyReadingListTab() {
            activateTab('HomeTabState', 'reading-list-tab');
            activateTabContent([{
                tabId: '#master-tab',
                tabContentId: '.tab-content.home-content #tab1'
            }, {
                tabId: '#what-new-tab',
                tabContentId: '.tab-content.home-content #tab2'
            }, {
                tabId: '#favorite-tab',
                tabContentId: '.tab-content.home-content #tab3'
            }],
                {
                    tabId: '#reading-list-tab',
                    tabContentId: '.tab-content.home-content #tab4'
                }, true);
        };

        function getTabStateType(tabType) {
            var type = '';
            switch (tabType) {
                case tabStateType.documentTabState:
                    type = tabStateType.documentTabState;
                    break;
                case tabStateType.chapterTabState:
                    type = tabStateType.chapterTabState;
                    break;
                case tabStateType.homeTabState:
                    type = tabStateType.homeTabState;
                    break;
                default:
                    type = tabStateType.documentTabState;
                    break;
            }

            return type;
        };

        function activateTab(tabState, tabId) {
            var tabStateType = getTabStateType(tabState);

            tabStateService.setState(tabStateType, tabId);
            tabStateService.setCurrentTabState(tabId);

        };

        function activateTabContent(inactiveItems, activeItem, notToggle) {
            for (var i = 0; i < inactiveItems.length; i++) {
                angular.element(inactiveItems[i].tabId).removeClass('active');
                angular.element(inactiveItems[i].tabContentId).removeClass('active');
            }
            if (!notToggle) {
                angular.element(activeItem.tabId).toggleClass('active');
                angular.element(activeItem.tabContentId).toggleClass('active');
            } else {
                angular.element(activeItem.tabId).addClass('active');
                angular.element(activeItem.tabContentId).addClass('active');
            }
        };
    };

    //helpPages
    helpPagesService.$inject = ['$http', '$q'];
    function helpPagesService($http, $q) {
        var service = {
            getHelpPages: getHelpPages
        };

        return service;

        function getHelpPages(viewId) {
            return $http.get(handbookRequests.GetHelpPagesRequest, { params: { 'viewId': viewId } })
                .then(function (response, status, headers, config) {
                    return response.data;
                });
        };
    };

    //configService
    configService.$inject = ['$http'];
    function configService($http) {

        var d_config;

        var service = {
            getDeviationConfig: getDeviationConfig,
            getDeviationConfigInServer: getDeviationConfigInServer,
            getBool: getBool,
            getString: getString,
            getInt: getInt
        };

        return service;

        var d_config;

        function getDeviationConfigInServer() {
            return $http.get(DeviationRequest.GetConfig)
                .success(function (response, status, headers, config) {
                    d_config = response;
                    return response;
                })
        }

        function getDeviationConfig() {
            return d_config;
        }

        function getBool(value) {

            if (typeof value === 'boolean') {
                return value;
            }

            if (!value || !value.trim()) {
                return false;
            }

            const compareValue = value.toString().trim().toLowerCase();

            return compareValue === "true";
        }

        function getString(value) {
            if (!value) {
                return '';
            }

            return value;
        }

        function getInt(value) {
            if (!value || !value.trim()) {
                return 0;
            }

            const compareValue = value.toString().trim();
            const parsedValue = parseInt(compareValue);

            return isNaN(parsedValue) ? 0 : parsedValue;
        }
    };

    commonService.$inject = ['$http', '$cookies', 'pubSub'];
    function commonService($http, $cookies, pubSub) {
        var service = {
            getCurrentLanguageText: getCurrentLanguageText
        };

        return service;

        function getCurrentLanguageText() {
            var result = user.currentLanguage;
            var language = $cookies.get(LANGUAGECULTURE);
            if (language && language.length) {
                result = language;
            }
            return (result ? result : LANGUAGES.NorwegianBokmal).toLowerCase();
        }
    }

    function getHearingTooltip(hearingMembers) {
        if (hearingMembers.length > 0) {
            hearingMembers.forEach(function (item) {
                if (item.hearingMemberComments.length > 0) {
                    var containerDiv = '<div class="comment-tooltip-body">';
                    var openTag = '<div class="table-css">';
                    var closeTag = '</div>';
                    var header = `<div class="table-row header">
													<span class="table-cell comment-tooltip-header  border-bottom">
														<span>${item.fullName} - ${resources.L.Document.comments}</span>
													</span>
												</div>`;
                    var openContentTag = '<div class="table-row body-content">';
                    var commentTooltipPadding = '';
                    item.hearingMemberComments.forEach(function (field) {
                        var hearingComment = '';
                        var fieldName = (field.fieldName == null ? resources.L.Document.wholeDocument : field.fieldName);
                        field.hearingComments.forEach(function (comment) {
                            hearingComment += `<div class="padding-top-5">
																<span class="comment-tooltip-element">${comment.createdDateStr} -</span>
																<span class="table-cell">${comment.commentDocumentText}</span>
															</div>`

                        });
                        commentTooltipPadding += `<div class="comment-tooltip-padding">
																	<div class="comment-tooltip-field">
																		${fieldName}:
																	</div>
																	${hearingComment}
																</div>`;
                    });

                    item.commentTooltip = `${containerDiv}
													${openTag}
														${header}
														${openContentTag}
															${commentTooltipPadding}
														${closeTag}
													${closeTag}
												${closeTag}`
                }
            });
        }
    }

})();